module.exports = __webpack_public_path__ + "static/img/whole_world.28c33ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/art/collage/whole_world.jpg
// module id = +pAz
// module chunks = 1